import { AppliedModelSortField, SortDirection } from '@/__generated__/graphql';
import { MAX_PAGE_SIZE } from './apiConstants';
import {
  AppliedModelsByEnvironmentParams,
  useDiscoveryAppliedModels,
} from './appliedModels';
import { useLoadAllPaginatedResults } from './loadAllPaginatedResults';

type UseMartsProps = AppliedModelsByEnvironmentParams & {
  includeQueryCount: boolean;
};

export const useMarts = ({
  first,
  environmentId,
  userId,
  includeQueryCount,
}: UseMartsProps) => {
  return useDiscoveryAppliedModels({
    first,
    environmentId,
    userId,
    filter: {
      modelingLayer: 'marts',
    },
    sort: {
      field: AppliedModelSortField.QueryUsageCount,
      direction: SortDirection.Desc,
    },
    includeQueryCount,
  });
};

export type AllMartsProps = Omit<AppliedModelsByEnvironmentParams, 'first'> & {
  loadingStrategy?: 'returnEachPage' | 'waitForAllResults';
};

export const useAllMarts = ({
  loadingStrategy = 'waitForAllResults',
  ...props
}: AllMartsProps) => {
  const martsQuery = useMarts({ ...props, first: MAX_PAGE_SIZE });
  return useLoadAllPaginatedResults({
    paginatedQuery: martsQuery,
    loadingStrategy,
  });
};
